/**
 * Consent translations for the cookie banner + preference center.
 * Covers 7 languages: FR, EN, RO, IT, DE, ES, ZH.
 */
export const CONSENT_LANGS = ["fr", "en", "ro", "it", "de", "es", "zh"];

export const CONSENT_LANG_LABELS = {
  fr: "Français",
  en: "English",
  ro: "Română",
  it: "Italiano",
  de: "Deutsch",
  es: "Español",
  zh: "中文",
};

export const CONSENT_T = {
  fr: {
    title: "Votre confidentialité",
    intro:
      "Pour améliorer votre expérience sur VlaDriver, nous utilisons des cookies nécessaires au fonctionnement du site. Avec votre accord, nous pouvons également utiliser des technologies facultatives.",
    optCookies: "J'accepte les cookies facultatifs (analytique, confort).",
    optPush: "J'accepte de recevoir des rappels de réservation par notifications push.",
    note: "Important : accepter les cookies n'autorise pas automatiquement les notifications push. Si vous les activez, votre navigateur vous demandera une autorisation séparée.",
    btnReject: "Tout refuser",
    btnCookiesOnly: "Cookies seuls",
    btnAcceptAll: "Tout accepter",
    btnManage: "Mes préférences",
    footerLink: "Cookies & Notifications",
    savedTitle: "Préférences enregistrées",
    savedBody: "Vous pouvez les modifier à tout moment depuis le pied de page.",
    revokePush: "Désactiver les notifications",
    revokePushDone: "Notifications désactivées.",
  },
  en: {
    title: "Your privacy",
    intro:
      "To improve your experience on VlaDriver, we use cookies required for the site to work. With your consent, we may also use optional technologies.",
    optCookies: "I accept optional cookies (analytics, convenience).",
    optPush: "I agree to receive booking reminders via push notifications.",
    note: "Important: accepting cookies does not automatically authorise push notifications. If enabled, your browser will ask for a separate permission.",
    btnReject: "Reject all",
    btnCookiesOnly: "Cookies only",
    btnAcceptAll: "Accept all",
    btnManage: "My preferences",
    footerLink: "Cookies & Notifications",
    savedTitle: "Preferences saved",
    savedBody: "You can change them anytime from the footer.",
    revokePush: "Disable notifications",
    revokePushDone: "Notifications disabled.",
  },
  ro: {
    title: "Confidențialitatea ta",
    intro:
      "Pentru a-ți îmbunătăți experiența pe VlaDriver, folosim cookie-uri necesare funcționării site-ului. Cu acordul tău, putem folosi și tehnologii opționale.",
    optCookies: "Accept cookie-urile opționale (analitice, confort).",
    optPush: "Accept să primesc reamintiri pentru rezervări prin notificări push.",
    note: "Important: acceptarea cookie-urilor nu autorizează automat notificările push. Dacă le activezi, browserul îți va cere o permisiune separată.",
    btnReject: "Refuză tot",
    btnCookiesOnly: "Doar cookie-uri",
    btnAcceptAll: "Acceptă tot",
    btnManage: "Preferințele mele",
    footerLink: "Cookie-uri & Notificări",
    savedTitle: "Preferințe salvate",
    savedBody: "Le poți modifica oricând din subsolul paginii.",
    revokePush: "Dezactivează notificările",
    revokePushDone: "Notificări dezactivate.",
  },
  it: {
    title: "La tua privacy",
    intro:
      "Per migliorare la tua esperienza su VlaDriver, utilizziamo cookie necessari al funzionamento del sito. Con il tuo consenso, possiamo utilizzare anche tecnologie facoltative.",
    optCookies: "Accetto i cookie facoltativi (analitici, comodità).",
    optPush: "Accetto di ricevere promemoria di prenotazione tramite notifiche push.",
    note: "Importante: accettare i cookie non autorizza automaticamente le notifiche push. Se le attivi, il browser chiederà un'autorizzazione separata.",
    btnReject: "Rifiuta tutto",
    btnCookiesOnly: "Solo cookie",
    btnAcceptAll: "Accetta tutto",
    btnManage: "Le mie preferenze",
    footerLink: "Cookie e Notifiche",
    savedTitle: "Preferenze salvate",
    savedBody: "Puoi modificarle in qualsiasi momento dal footer.",
    revokePush: "Disattiva le notifiche",
    revokePushDone: "Notifiche disattivate.",
  },
  de: {
    title: "Ihre Privatsphäre",
    intro:
      "Um Ihr Erlebnis auf VlaDriver zu verbessern, verwenden wir für den Betrieb notwendige Cookies. Mit Ihrer Zustimmung können wir auch optionale Technologien einsetzen.",
    optCookies: "Ich akzeptiere optionale Cookies (Analyse, Komfort).",
    optPush: "Ich bin damit einverstanden, Buchungserinnerungen per Push-Benachrichtigung zu erhalten.",
    note: "Wichtig: Die Annahme von Cookies autorisiert Push-Benachrichtigungen nicht automatisch. Bei Aktivierung fragt Ihr Browser separat um Erlaubnis.",
    btnReject: "Alle ablehnen",
    btnCookiesOnly: "Nur Cookies",
    btnAcceptAll: "Alle akzeptieren",
    btnManage: "Meine Einstellungen",
    footerLink: "Cookies & Benachrichtigungen",
    savedTitle: "Einstellungen gespeichert",
    savedBody: "Sie können sie jederzeit über die Fußzeile ändern.",
    revokePush: "Benachrichtigungen deaktivieren",
    revokePushDone: "Benachrichtigungen deaktiviert.",
  },
  es: {
    title: "Tu privacidad",
    intro:
      "Para mejorar tu experiencia en VlaDriver, utilizamos cookies necesarias para el funcionamiento del sitio. Con tu consentimiento, también podemos utilizar tecnologías opcionales.",
    optCookies: "Acepto las cookies opcionales (analíticas, comodidad).",
    optPush: "Acepto recibir recordatorios de reserva mediante notificaciones push.",
    note: "Importante: aceptar las cookies no autoriza automáticamente las notificaciones push. Si las activas, tu navegador pedirá un permiso aparte.",
    btnReject: "Rechazar todo",
    btnCookiesOnly: "Solo cookies",
    btnAcceptAll: "Aceptar todo",
    btnManage: "Mis preferencias",
    footerLink: "Cookies y Notificaciones",
    savedTitle: "Preferencias guardadas",
    savedBody: "Puedes cambiarlas en cualquier momento desde el pie de página.",
    revokePush: "Desactivar notificaciones",
    revokePushDone: "Notificaciones desactivadas.",
  },
  zh: {
    title: "您的隐私",
    intro:
      "为了改善您在 VlaDriver 的体验，我们使用网站运行所需的 Cookie。在您的同意下，我们也可以使用可选的技术。",
    optCookies: "我接受可选 Cookie（分析、便利）。",
    optPush: "我同意通过推送通知接收预订提醒。",
    note: "重要提示：接受 Cookie 并不自动授权推送通知。如启用，您的浏览器会单独询问授权。",
    btnReject: "全部拒绝",
    btnCookiesOnly: "仅接受 Cookie",
    btnAcceptAll: "全部接受",
    btnManage: "我的偏好",
    footerLink: "Cookie 和通知",
    savedTitle: "偏好已保存",
    savedBody: "您可以随时在页脚中更改它们。",
    revokePush: "禁用通知",
    revokePushDone: "通知已禁用。",
  },
};

/**
 * Normalize any browser language code (navigator.language or site i18n) to one of CONSENT_LANGS.
 * Fallback = fr.
 */
export function pickConsentLang(raw) {
  if (!raw) return "fr";
  const code = String(raw).toLowerCase().replace("_", "-");
  const primary = code.split("-", 1)[0].split(",", 1)[0];
  if (CONSENT_LANGS.includes(primary)) return primary;
  return "fr";
}
